import React, { useMemo } from 'react';
// import { Tabs } from 'react-bootstrap';
import { Switch, Route, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import SubHeader from '../../../../../_psb/layout/sub-header/SubHeader';
import PublicInquiryList from './myArtisanPublicInquiriesList';
import ViewPublicInquiry from './viewArtisanPublicInquiry';
import ViewPublicPrososal from './viewArtisanProposal';
import viewArtisanProposalPending from './viewArtisanProposalPending';
import myProposalList from './myProposalList';
import MyProposalPendingList from './myProposalPendingList';

import { getArtisanCategoriesAction } from '../../../../../modules/artisanCategories/Actions';

import { artisanCategoriesAsLabelAndValueSelector } from '../../../../../modules/artisanCategories/Selectors';

import Tabs from '../../../../../components/UI/tab/Tabs';
import { Formik } from 'formik';
import { SearchableSelect } from '../../../../../components/form';
import getLangData from '../../../../../utils/getLangData';

const PublicInquiry = props => {
  const tabsProps = useMemo(() => ({
    base: '/my-public-inquiries-artisan',
    items: [
      { title: getLangData().general_words.view_public_inquiry, page: '/' },
      { title: getLangData().general_words.view_my_proposals, page: '/my-public-proposals/artisan' },
      {
        title: getLangData().general_words.view_my_pending_proposals,
        page: '/my-pending-public-proposals/artisan'
      }
    ]
  }));
  const { artisanCategories, getArtisanCategories } = props;

  return (
    <>
      <SubHeader title={getLangData().general_words.public_inquiry}>
        <Switch>
          <Route
            exact
            path={[
              '/my-public-inquiries-artisan',
              '/my-public-inquiries-artisan/my-public-proposals/artisan',
              '/my-public-inquiries-artisan/my-pending-public-proposals/artisan'
            ]}
            render={() => <Tabs {...tabsProps} />}
          />
          {/* <Route
            exact
            path="/my-public-inquiries-artisan"
            render={
              // <Formik>
              //   <SearchableSelect
              //     name="artisanCID"
              //     label="Category"
              //     // getItems={getCategories}
              //     options={artisanCategories}
              //     // isLoading={publicInquiriesIsLoading}
              //   />
              // </Formik>
              <h1>Filter Catgories</h1>
            }
          /> */}
          {/* <Route
            exact
            path={["/my-public-inquiries-artisan/:id", '/my-public-inquiries-artisan/my-public-proposals/artisan/:id' ]}
            render={({ match: { params } }) => {
              return (
                <Link
                  to={`/my-public-inquiries-artisan`}
                  className="btn-label-brand btn btn-bold"
                >
                  Back To List
                </Link>
              );
            }}
          /> */}
        </Switch>
      </SubHeader>
      <Switch>
        <Route
          exact
          component={PublicInquiryList}
          path='/my-public-inquiries-artisan'
        />
        <Route
          exact
          component={ViewPublicInquiry}
          path='/my-public-inquiries-artisan/:id'
        />
        <Route
          exact
          component={myProposalList}
          path='/my-public-inquiries-artisan/my-public-proposals/artisan/'
        />
        <Route
          exact
          component={ViewPublicPrososal}
          path='/my-public-inquiries-artisan/my-public-proposals/artisan/:id'
        />
        <Route
          exact
          component={MyProposalPendingList}
          path='/my-public-inquiries-artisan/my-pending-public-proposals/artisan'
        />
        <Route
          exact
          component={viewArtisanProposalPending}
          path='/my-public-inquiries-artisan/my-pending-public-proposals/artisan/:id'
        />
        {/*
      <Route
      exact
      component={ViewPublicInquiry}
      path='/customer-public-inquiry-artisan/create'
    /> */}
      </Switch>
    </>
  );
};

const mapStateToProps = state => ({
  artisanCategories: artisanCategoriesAsLabelAndValueSelector(state)
});

const mapDispatchToProps = {
  getArtisanCategories: getArtisanCategoriesAction
};

export default connect(mapStateToProps, mapDispatchToProps)(PublicInquiry);
